import type { Terminal } from '@xterm/xterm';

/**
 * Beyond this the sheet stops being a quote and becomes a dump — nobody scrolls two
 * thousand lines on a phone, and the clipboard blob would be unusable anyway. The cap
 * applies to inline Codex and shell history; alternate-screen applications have a buffer
 * of exactly one screenful.
 */
const MAX_LINES = 1000;

/**
 * The terminal's contents as plain text, ready to be selected and copied.
 *
 * `buffer.active` rather than the viewport: on the normal screen that includes the
 * scrollback tmux seeded on attach, so a shell session yields its history and not just
 * the last twenty-four rows. On the alternate screen the
 * two are the same thing, because there is no scrollback to include.
 */
export function bufferText(term: Terminal): string {
  const buf = term.buffer.active;
  const lines: string[] = [];

  for (let y = Math.max(0, buf.length - MAX_LINES); y < buf.length; y++) {
    const line = buf.getLine(y);
    if (!line) continue;
    // `false`, so the padding survives long enough to be joined: a wrapped row is the
    // tail of the row above it, not a line of its own, and gluing them back together is
    // what makes a long path or URL copy as one string instead of arriving broken at
    // whatever column the terminal happened to run out of.
    const text = line.translateToString(false);
    if (line.isWrapped && lines.length > 0) lines[lines.length - 1] += text;
    else lines.push(text);
  }

  const out = lines.map((l) => l.replace(/\s+$/u, ''));
  while (out.length > 0 && out[0] === '') out.shift();
  while (out.length > 0 && out[out.length - 1] === '') out.pop();
  return out.join('\n');
}
